import { render, staticRenderFns } from "./ConexaoHub.vue?vue&type=template&id=54ae7bb5&scoped=true"
import script from "./ConexaoHub.vue?vue&type=script&lang=js"
export * from "./ConexaoHub.vue?vue&type=script&lang=js"
import style0 from "./ConexaoHub.vue?vue&type=style&index=0&id=54ae7bb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ae7bb5",
  null
  
)

export default component.exports